<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @todoCheck="todoCheckFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.storeName"
              placeholder="请输入店名"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <date-select :search-date.sync="masterList.tableQuery.searchDate" />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.status"
              placeholder="请选择单据状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun()"
        @edit="editFun(arguments)"
        @del="delFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 新增 修改-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />

    <!-- 待办列表 -->
    <task-list-dialog
      :dialog-visible.sync="dialogTaskVisible"
      dialog-title="待复核终端恢复申请清单"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 日期选择
import DateSelect from '@/components/DateSelect'
// 新增 修改
import addEditViewDialog from './components/addEditViewDialog'
// 待办列表
import taskListDialog from './components/taskListDialog'
// 权限验证
import checkPermission from '@/utils/permission'
// 终端恢复申请API
import { loadSchemeStoreVisitRestoreApplyListDataApi, exportSchemeStoreVisitRestoreApplyListDataApi, countTodoSchemeStoreVisitRestoreApplyApi, deleteSchemeStoreVisitRestoreApplyApi } from '@/api/v2/schemeStoreVisitRestoreApply';

export default {
  name: 'SchemeStoreVisitRestoreApplyView',
  components: {
    CustomTable2,
    TableOperation2,
    DateSelect,
    addEditViewDialog,
    taskListDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data() {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'scheme_store_visit_restore_apply_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['scheme_store_visit_restore_apply_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['scheme_store_visit_restore_apply_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['scheme_store_visit_restore_apply_del'],
            prop: 'del',
            label: '作废',
            method: 'del'
          },
          {
            permissionSigns: ['scheme_store_visit_restore_apply_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['scheme_store_visit_restore_apply_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          schemeNo: '',
          storeName: '',
          certificateNo: '',
          searchDate: '',
          status: ''
        }
      },
      // 待办
      todoList: [
        { permissionSigns: ['scheme_store_visit_restore_apply_check'], label: '待复核的终端恢复申请', method: 'todoCheck', count: 0}
      ],
      statusOptions: [{ value: 1, label: '制单' }, { value: 2, label: '复核' }],
      id: null,
      eventType: '',
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',
      dialogTaskVisible: false
    }
  },
  created() {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'tsi.province_name', width: 100 },
      { prop: 'cityName', label: '城市', filterColumn: 'tsi.city_name', width: 100 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'ts.project_no', width: 200 },
      { prop: 'schemeName', label: '方案名称', filterColumn: 'ts.name', width: 200 },
      { prop: 'certificateNo', label: '申请专卖证号', filterColumn: 'tsi.certificate_no', width: 160 },
      { prop: 'storeName', label: '申请店名', filterColumn: 'tsi.store_name', width: 160 },
      { prop: 'address', label: '申请店地址', filterColumn: 'tsi.address', width: 160 },
      { prop: 'realStoreName', label: '实际店名', filterColumn: 'tsi.real_store_name', width: 160 },
      { prop: 'realAddress', label: '实际地址', filterColumn: 'tsi.real_address', width: 160 },
      { prop: 'applyDate', label: '申请日期', filterColumn: 'tssvra.apply_date', width: 120 },
      { prop: 'applyDescription', label: '申请说明', filterColumn: 'tssvra.apply_description', width: 180 },
      { prop: 'stopCertificateNo', label: '停用专卖证号', filterColumn: 'tsi2.certificate_no', width: 160 },
      { prop: 'stopStoreName', label: '停用店名', filterColumn: 'tsi2.store_name', width: 160 },
      { prop: 'stopAddress', label: '停用店地址', filterColumn: 'tsi2.address', width: 160 },
      { prop: 'stopRealStoreName', label: '停用实际店名', filterColumn: 'tsi2.real_store_name', width: 160 },
      { prop: 'stopRealAddress', label: '停用实际地址', filterColumn: 'tsi2.real_address', width: 160 },
      { prop: 'checkResultValue', label: '复核结果', filterColumn: 'tssvra.check_result', filterValue: 'checkResult', filterArray: [{ label: '通过', value: 1 }, { label: '不通过', value: 2 }], width: 120 },
      { prop: 'statusValue', label: '状态', filterColumn: 'tssvra.status', filterValue: 'status', filterArray: [{ label: '制单', value: 1 }, { label: '复核', value: 2 }], width: 80 },
      { prop: 'remark', label: '备注', filterColumn: 'tssvra.remark', width: 200 },
      { prop: 'creatorName', filterColumn: 'tssvra.creator_name', label: '创建人', width: 120 },
      { prop: 'createTime', filterColumn: 'tssvra.create_time', label: '创建时间', width: 150, isBetween: true },
      { prop: 'checkName', filterColumn: 'tssvra.check_name', label: '复核人', width: 120 },
      { prop: 'checkTime', filterColumn: 'tssvra.check_time', label: '复核时间', width: 150, isBetween: true },
      { prop: 'operatorName', filterColumn: 'tssvra.operator_name', label: '操作人', width: 120 },
      { prop: 'operationTime', filterColumn: 'tssvra.operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData() {
      let _this = this;
      loadSchemeStoreVisitRestoreApplyListDataApi(_this.masterList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount() {
      let _this = this;
      // 待复核
      if (checkPermission(['scheme_store_visit_restore_apply_check'])) {
        countTodoSchemeStoreVisitRestoreApplyApi({ status: 1 }).then((response) => {
          _this.todoList[0].count = response.data || 0;
        })
      }
    },
    // 审核
    todoCheckFun() {
      this.dialogTaskVisible = !this.dialogTaskVisible
    },
    addFun(){
      let _this = this;
      _this.eventType = 'add'
      _this.dialogAddEditTitle = '新增终端恢复申请'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 修改
    editFun(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的终端恢复申请', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        _this.$message({ message: '终端恢复申请不在制单状态，不能修改', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogAddEditTitle = '修改终端恢复申请'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 查看
    viewFun(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的终端恢复申请', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogAddEditTitle = '查看终端恢复申请'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 作废
    delFun(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要作废的终端恢复申请', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        _this.$message({ message: '终端恢复申请不在制单状态，不能作废', type: 'warning' })
        return
      }
      _this.$confirm('是否确定作废该终端恢复申请？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        deleteSchemeStoreVisitRestoreApplyApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '作废成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 导出数据API
    exportByPage() {
      let _this = this;
      exportSchemeStoreVisitRestoreApplyListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
